import { FC, ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { Box, Grid, alpha, lighten, useTheme } from "@mui/material";

import Sidebar from "./Sidebar";

interface Props {
  children?: ReactNode;
}

const FuncComponent: FC<Props> = () => {
  const theme = useTheme();

  return (
    <Grid className="fixed-width-container">
      <Box
        sx={{
          flex: 1,
          height: "100%",

          ".MuiPageTitle-wrapper": {
            background:
              theme.palette.mode === "dark"
                ? theme.colors.alpha.trueWhite[5]
                : theme.colors.alpha.white[50],
            marginBottom: `${theme.spacing(4)}`,
            boxShadow:
              theme.palette.mode === "dark"
                ? `0 1px 0 ${alpha(
                    lighten(theme.colors.primary.main, 0.7),
                    0.15
                  )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                : `0px 2px 4px -3px ${alpha(
                    theme.colors.alpha.black[100],
                    0.1
                  )}, 0px 5px 12px -4px ${alpha(
                    theme.colors.alpha.black[100],
                    0.05
                  )}`,
          },
        }}
      >
        <Sidebar />
        <Box
          sx={{
            flex: 1,
            zIndex: 5,
            pt: `30px`,
            display: "block",
            position: "relative",
            ml: `${theme.sidebar.width}`,
          }}
        >
          <Box display="block">
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default FuncComponent;
